// 🛡️ Polyfills leves para WebViews antigas (MIUI / ColorOS / Redmi / Oppo).
// Importado como PRIMEIRO import do main.tsx para rodar antes de qualquer lib.
try {
  if (!(Object as any).hasOwn) {
    (Object as any).hasOwn = (o: any, k: PropertyKey) => Object.prototype.hasOwnProperty.call(o, k);
  }
  if (!(Array.prototype as any).at) {
    Object.defineProperty(Array.prototype, 'at', {
      value: function (n: number) { n = Math.trunc(n) || 0; if (n < 0) n += this.length; return this[n]; },
      writable: true, configurable: true,
    });
  }
  if (!(String.prototype as any).replaceAll) {
    Object.defineProperty(String.prototype, 'replaceAll', {
      value: function (a: any, b: any) {
        return a instanceof RegExp ? this.replace(a, b) : this.split(a).join(b);
      },
      writable: true, configurable: true,
    });
  }
  if (typeof (globalThis as any).structuredClone !== 'function') {
    (globalThis as any).structuredClone = (v: any) => JSON.parse(JSON.stringify(v));
  }
  if (typeof window !== 'undefined') {
    if (!window.crypto) (window as any).crypto = {};
    if (!window.crypto.randomUUID) {
      (window.crypto as any).randomUUID = () =>
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = (Math.random() * 16) | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    }
  }
} catch (_) { /* ignore */ }

export {};
